import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { CustomerDashboardCounter } from '../../../models/domain/CustomerDashboardCounter';

@Component({
    selector: 'app-order-stats',
    imports: [CommonModule, RouterLink],
    templateUrl: './order-stats.component.html',
    styleUrl: './order-stats.component.scss'
})
export class OrderStatsComponent {
    @Input() dashboardCounter = new CustomerDashboardCounter();

    constructor(public themeService: CustomizerSettingsService) {}
}
